// extracted by mini-css-extract-plugin
export default {"btn_us":"My","btn_us_active":"Ny","btn_metric":"Oy","btn_metric_active":"Py","metrics_btn_wrapper":"Qy","btn_us_profile":"Ry","btn_us_profile_active":"Sy","btn_metric_profile":"Ty","btn_metric_profile_active":"Uy"};
    if(module.hot) {
      // 1721922363821
      var cssReload = require("../../../node_modules/mini-css-extract-plugin/dist/hmr/hotModuleReplacement.js")(module.id, {"locals":true});
      module.hot.dispose(cssReload);
      
    }
  